export default __webpack_public_path__ + "static/4-d8737d59bf46820394e04f8e5da6578b.jpg";